import { z } from "zod";
import superjson from "superjson";
import { SubscriptionStatus, SubscriptionPlanType } from "../../helpers/schema";

export const schema = z.object({});

export type InputType = z.infer<typeof schema>;

export type OutputType = {
  organization: {
    id: number;
    name: string;
    slug: string;
    logoUrl: string | null;
    primaryColor: string | null;
    secondaryColor: string | null;
    ownerUserId: number | null;
    isDemo: boolean;
    createdAt: Date | null;
    updatedAt: Date | null;
    subscription: {
      status: SubscriptionStatus;
      planName: string;
      planType: SubscriptionPlanType;
      currentPeriodEnd: Date | null;
      trialEndsAt: Date | null;
      limits: {
        maxProperties: number | null;
        maxUnitsPerProperty: number | null;
        maxUsers: number | null;
      };
    } | null;
    memberCount: number;
    defaultCurrency: string;
  } | null;
};

export const getCurrentOrganization = async (
  body: InputType = {},
  init?: RequestInit
): Promise<OutputType> => {
  const result = await fetch(`/_api/organizations/current`, {
    method: "GET",
    ...init,
    headers: {
      "Content-Type": "application/json",
      ...(init?.headers ?? {}),
    },
  });
  if (!result.ok) {
    const errorObject = superjson.parse<{ error: string }>(await result.text());
    throw new Error(errorObject.error);
  }
  return superjson.parse<OutputType>(await result.text());
};